/**
 * Error Page Configuration
 *
 * Configuration for error pages (404, 500, etc.)
 * Contains GIPHY image URLs used as background images on error pages.
 *
 * To update the GIFs:
 * 1. Find a new GIF on GIPHY
 * 2. Copy the GIF URL (e.g., https://media.giphy.com/media/XXXXX/giphy.gif)
 * 3. Copy the GIPHY page URL (e.g., https://giphy.com/gifs/XXXXX)
 * 4. Update the corresponding image object below
 */

export const IMAGE_404 = {
  src: 'https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExM3g2bjJ6cnE3NnF0b3Zxb2R1MDIyZjBnZGJxODVod293NDdhMGozMiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/fv9tQNciAr11m/giphy.gif',
  href: 'https://giphy.com/gifs/dope-trill-chief-keef-fv9tQNciAr11m',
};

export const IMAGE_500 = {
  src: 'https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExb202eW95b2Iwa21na203ODg2b3BxdmR4Mjh1eHZjaTc0cWxvbjB3byZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/MivJ2E37lXdio/giphy.gif',
  href: 'https://giphy.com/gifs/gbe-glo-akidnamedmat-MivJ2E37lXdio',
};
